import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import DietaryPreferencesPage from "./dietary-preferences-page";
import DietaryPreferenceCreatePage from "./dietary-preference-create-page";
import DietaryPreferenceEditPage from "./dietary-preference-edit-page";
 

export default (
  <Route path="dietary-preferences">
    <Route
      index
      element={
        <Protected
          path="/admin/dietary-preferences"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <DietaryPreferencesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/dietary-preferences/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <DietaryPreferenceCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/dietary-preferences/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <DietaryPreferenceEditPage />
        </Protected>
      }
    />  
  </Route>
);



